import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { ModelRow } from "@mcleod/core";
import { TruckOrderNotUsed } from "../../TruckOrderNotUsed";

export class RowActionTonu extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonTonu;
    }

    override getButtonId(): string {
        return "buttonTonu";
    }

    override getFieldsUsedInThisFile(): string[] {
        return [];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap:ReasonMap): void {
        const modelRow = selectedRows[0];  // no multi-select
        const orderStatus = modelRow.getString("order_status");
        if ("A" !== orderStatus) {
            if (orderStatus == null || modelRow.getBoolean("emptied", false))
                this.addReason(reasonMap, "is_emptied", "TONU cannot be processed for empty movements.");
            else
                this.addReason(reasonMap, "invalid_status", "TONU can only be processed for available orders.");
        }
        if (modelRow.getBoolean("brokerage", false)) {
            this.addReason(reasonMap, "is_brokerage", "TONU cannot be processed for brokerage orders.");
        }
        if (!modelRow.isNull("manifest_id")) {
            this.addReason(reasonMap, "is_manifested", "Order must be dropped from manifest before " +
                "proceeding with TONU.");
        }
        const orderMode = modelRow.getString("order_mode");
        if (orderMode === "L" || orderMode === "P") {
            this.addReason(reasonMap, "invalid_mode", "TONU cannot be processed for Partial or LTL orders.");
        }
        if (modelRow.getBoolean("is_ysplit", false)) {
            this.addReason(reasonMap, "is_ysplit", "TONU is not allowed for Y-Splits. Please remove the " +
                "Y-Split before proceeding.");
        }
    }

    override execute(props: PlanningTableRowActionProps) {
        const modelRow = props.selectedRows[0]?.data as ModelRow;
        const orderId = modelRow.getString("order_id");
        const driverId = modelRow.getString("driver1_id");

        TruckOrderNotUsed.openSlideout({ orderId, driverId, doAfterSave: () => TruckOrderNotUsed.showSuccessToast(orderId) });
    }
}
